// Version 2 uses one coordinated facial expression.
// Eye shape, eye color, hair color and clothing color
// are independent additive options.

export const defaultAvatar = Object.freeze({
  version: 2,
  characterType: 'human_male',
  head: 'circle',
  skinTone: 'skin_03',
  eyeShape: 'oval_01',
  eyeColor: 'eye_color_01',
  expression: 'happy_01',
  hair: 'short_01',
  hairColor: 'hair_color_01',
  clothing: 'tshirt_01',
  clothingColor: 'clothing_color_01',
  background: 'bg_01',
});

// Returns a fresh configuration for each creator session.
export function createDefaultAvatar() {
  return { ...defaultAvatar };
}

// Fill absent fields in older saved configurations.
// Preserve supplied values without modifying the original object.
// This supplies defaults; backend validation still checks saved input.
export function normalizeAvatarConfig(config = {}) {
  return {
    ...defaultAvatar,
    ...config,
  };
}
